<!--
使用海水登録画面
URL：seawater
-->

<template>
  <div>
    <v-container style="max-width: 800px" v-show="view_status.editable">
      <p class="text-center text-h3">使用海水</p>
      <alert :errors="errors" css_class="ma-1"></alert>
      <v-card elevation="5" class="ma-4">
        <v-card-title class="custom-card-title">確認日</v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <custom-date-picker
                :dateSub="dateSub"
                :events="events"
                :defaultFocus="dateSub"
                @on-update-registration-date="updateRegistrationDate"
                @on-update-calendar-month="updateCalendarEvent"
              ></custom-date-picker>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <v-card elevation="5" class="ma-4">
        <v-card-title class="custom-card-title">ろ過器の管理</v-card-title>
        <v-card-subtitle class="custom-card-subtitle"
          >※複数選択可</v-card-subtitle
        >
        <v-card-text>
          <v-row>
            <v-col cols="auto">
              <v-checkbox
                class="big-checkbox"
                label="逆洗"
                color="#0ddbc7"
                v-model="filterBackwash"
              ></v-checkbox>
              <v-checkbox
                class="big-checkbox"
                label="ろ材補充"
                color="#0ddbc7"
                v-model="filterSupply"
              ></v-checkbox>
              <v-checkbox
                class="big-checkbox"
                label="ろ材交換"
                color="#0ddbc7"
                v-model="filterExchange"
              ></v-checkbox>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <v-card
        elevation="5"
        :class="{ 'card-error': cardColor3 == 30 }"
        class="ma-4"
      >
        <v-card-title class="custom-card-title">殺菌装置</v-card-title>
        <v-card-subtitle class="custom-card-subtitle"
          >※複数選択可</v-card-subtitle
        >
        <v-card-text>
          <v-row v-if="chlorineConcentrationMsg" align-content="center">
            <v-col cols="auto" align="left">
              <font color="red" class="custom-card-text">{{
                chlorineConcentrationMsg
              }}</font>
            </v-col>
          </v-row>
          <v-row v-if="uvMsg" align-content="center">
            <v-col cols="auto" align="left">
              <font color="red" class="custom-card-text">{{ uvMsg }}</font>
            </v-col>
          </v-row>
          <v-col>
            <v-row align="center">
              <v-col>
                <v-checkbox
                  class="big-checkbox"
                  label="塩素"
                  color="#0ddbc7"
                  v-model="chlorine"
                ></v-checkbox>
              </v-col>
              <v-col>
                <p
                  style="text-align: right; top: 5px; position: relative"
                  class="custom-card-text"
                >
                  残留塩素濃度:
                </p>
              </v-col>
              <v-col>
                <v-text-field
                  :Width="12"
                  color="#0ddbc7"
                  ref="formData.chlorineConcentration"
                  v-model.number="$v.formData.chlorineConcentration.$model"
                  maxlength="8"
                  regular
                  hide-details="auto"
                  dense
                  class="text-h6 text-align:center"
                  :disabled="!chlorine"
                  :error-messages="chlorineConcentrationErrorMessage"
                ></v-text-field>
              </v-col>
              <v-col>
                <p
                  style="text-align: left; top: 5px; position: relative"
                  class="custom-card-text"
                >
                  ppm
                </p>
              </v-col>
            </v-row>
            <v-row align="center">
              <v-col>
                <v-checkbox
                  class="big-checkbox"
                  label="紫外線"
                  color="#0ddbc7"
                  v-model="uv"
                ></v-checkbox>
              </v-col>
              <v-col>
                <p
                  style="text-align: right; top: 5px; position: relative"
                  class="custom-card-text"
                >
                  殺菌機稼働:
                </p>
              </v-col>
              <v-col>
                <v-radio-group
                  row
                  v-model="uvStatus"
                  class="big-radio-group"
                  :disabled="!uv"
                >
                  <v-radio label="適" color="#0ddbc7" :value="1"></v-radio>
                  <v-radio label="不適" color="#0ddbc7" :value="2"></v-radio>
                </v-radio-group>
              </v-col>
            </v-row>
          </v-col>
        </v-card-text>
      </v-card>

      <v-card
        elevation="5"
        :class="{ 'card-warning': cardColor4 == 20 }"
        class="ma-4"
      >
        <v-card-title class="custom-card-title">冷却海水温度</v-card-title>
        <v-card-text>
          <v-row v-if="seawaterTemperatureMsg" align-content="center">
            <v-col cols="auto" align="left">
              <font color="red" class="custom-card-text">{{
                seawaterTemperatureMsg
              }}</font>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-text-field
                :Width="12"
                color="#0ddbc7"
                ref="formData.seawaterTemperature"
                v-model="$v.formData.seawaterTemperature.$model"
                maxlength="8"
                regular
                hide-details="auto"
                dense
                class="text-h6 text-align:center"
                :error-messages="seawaterTemperatureErrorMessage"
              ></v-text-field>
            </v-col>
            <v-col>
              <p
                style="text-align: left; top: 5px; position: relative"
                class="custom-card-text"
              >
                ℃
              </p>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <v-card
        elevation="5"
        :class="{ 'card-error': cardColor5 == 30 }"
        class="ma-4"
      >
        <v-card-title class="custom-card-title">塩分濃度</v-card-title>
        <v-card-text>
          <v-row v-if="salinityMsg" align-content="center">
            <v-col cols="auto" align="left">
              <font color="red" class="custom-card-text">{{
                salinityMsg
              }}</font>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-text-field
                :Width="12"
                color="#0ddbc7"
                ref="formData.salinity"
                v-model.number="$v.formData.salinity.$model"
                maxlength="8"
                regular
                hide-details="auto"
                dense
                class="text-h6 text-align:center"
                :error-messages="salinityErrorMessage"
              ></v-text-field>
            </v-col>
            <v-col>
              <p
                style="text-align: left; top: 5px; position: relative"
                class="custom-card-text"
              >
                ％
              </p>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <v-row justify="center" style="text-align: center">
        <v-col cols="6">
          <v-btn
            color="secondary"
            outlined
            style="font-size: 24px"
            class="ma-2"
            width="200"
            height="50"
            @click="cancel"
            >やめる</v-btn
          >
        </v-col>
        <v-col cols="6">
          <v-btn
            color="primary"
            style="font-size: 24px"
            class="ma-2"
            width="200"
            height="50"
            @click="inputCheck"
            :disabled="!view_status.editable"
            >保存</v-btn
          >
        </v-col>
      </v-row>
    </v-container>
    <!-- 入力チェックダイアログ -->
    <confirm-dialog ref="confirm_input_check" @on-click-ok="register">
      <p v-if="chlorineConcentrationMsg">
        殺菌装置-塩素:{{ chlorineConcentrationMsg }}
      </p>
      <p v-if="uvMsg">殺菌装置-紫外線 :{{ uvMsg }}</p>
      <p v-if="seawaterTemperatureMsg">
        冷却海水温度:{{ seawaterTemperatureMsg }}
      </p>
      <p v-if="salinityMsg">塩分濃度:{{ salinityMsg }}</p>
    </confirm-dialog>
  </div>
</template>

<script>
import CustomDatePicker from "../components/record-update/custom-date-picker.vue";
import Api from "@/logic/api/api.js";
import DateWrapper from "../logic/common/date-wrapper";
import Alert from "../components/common/alert.vue";
import AlertBuilder from "../logic/common/alert-contents";
import valueMapper from "../logic/common/value-mapper";
import Validate from "@/logic/common/validate.js";
import ConfirmDialog from "../components/dialog/confirmWkReg.vue";

const CARD_COLOR_NOMAL = 10;
const CARD_COLOR_WARNING = 20;
const CARD_COLOR_ERROR = 30;

export default {
  components: {
    "custom-date-picker": CustomDatePicker,
    "confirm-dialog": ConfirmDialog,
    alert: Alert,
  },
  /**
   * 出入力の検証
   */
  validations: {
    formData: {
      // 残留塩素濃度
      chlorineConcentration: {
        unsignedDecimalNumber: Validate.rule.unsignedDecimalNumber,
      },
      // 冷却海水温度
      seawaterTemperature: {
        signedDecimalNumber: Validate.rule.signedDecimalNumber,
      },
      // 塩分濃度
      salinity: {
        unsignedDecimalNumber: Validate.rule.unsignedDecimalNumber,
      },
    },
  },
  computed: {
    /**
     * formDataの入力が不正ならtrueを返す
     */
    hasErrorFormData() {
      return Validate.hasError([
        this.$v.formData.chlorineConcentration,
        this.$v.formData.seawaterTemperature,
        this.$v.formData.salinity,
      ]);
    },
    /**
     * エラーメッセージ：残留塩素濃度
     */
    chlorineConcentrationErrorMessage() {
      return Validate.buildLocalizedErrorMessage(
        this.$v.formData.chlorineConcentration,
        "残留塩素濃度",
        ["unsignedDecimalNumber"]
      );
    },
    /**
     * エラーメッセージ：冷却海水温度
     */
    seawaterTemperatureErrorMessage() {
      return Validate.buildLocalizedErrorMessage(
        this.$v.formData.seawaterTemperature,
        "冷却海水温度",
        ["signedDecimalNumber"]
      );
    },
    /**
     * エラーメッセージ：塩分濃度
     */
    salinityErrorMessage() {
      return Validate.buildLocalizedErrorMessage(
        this.$v.formData.salinity,
        "塩分濃度",
        ["unsignedDecimalNumber"]
      );
    },
    /**
     * 業務チェック：残留塩素濃度
     */
    chlorineConcentrationMsg: function () {
      if (this.chlorine) {
        if (
          Validate.hasError([this.$v.formData.chlorineConcentration]) ||
          this.formData.chlorineConcentration === ""
        ) {
          return "残留塩素濃度の入力がありません。";
        } else if (
          this.formData.chlorineConcentration < 0.1 ||
          0.3 < this.formData.chlorineConcentration
        ) {
          return "残留塩素濃度の正常値は0.1～0.3ppmです";
        }
      }
      return "";
    },
    /**
     * 業務チェック：紫外線
     */
    uvMsg: function () {
      if (this.uv) {
        if (this.uvStatus == "" || this.uvStatus == 2) {
          return "紫外線稼働状況を確認してください";
        }
      }
      return "";
    },
    /**
     * 業務チェック：冷却海水温度
     */
    seawaterTemperatureMsg: function () {
      if (this.hasErrorSeawaterTemperature()) {
        return "（生食用）冷却海水温度の入力がありません。";
      } else {
        return "";
      }
    },
    /**
     * 業務チェック：塩分濃度
     */
    salinityMsg: function () {
      if (this.hasErrorSalinity()) {
        return "";
      } else {
        if (this.formData.salinity < 2) {
          return "正常値は2%以上です（希釈しないこと）";
        }
      }
      return "";
    },
    /**
     * カード色
     */
    // 殺菌装置
    cardColor3: function () {
      if (!this.chlorine && !this.uv) {
        return CARD_COLOR_ERROR;
      } else {
        return CARD_COLOR_NOMAL;
      }
    },
    // 冷却海水温度
    cardColor4: function () {
      if (this.hasErrorSeawaterTemperature()) {
        return CARD_COLOR_WARNING;
      } else {
        return CARD_COLOR_NOMAL;
      }
    },
    // 塩分濃度
    cardColor5: function () {
      if (this.hasErrorSalinity()) {
        return CARD_COLOR_ERROR;
      } else {
        return CARD_COLOR_NOMAL;
      }
    },
  },
  data() {
    var today = new Date();
    let year = today.getFullYear();
    let month = ("0" + (today.getMonth() + 1)).slice(-2);
    let date = ("0" + today.getDate()).slice(-2);
    // api登録用形式の日付
    this.date_api = year + "/" + month + "/" + date;

    // ろ過器の管理
    this.filterMaintenance = ""; //初期値
    // 殺菌装置
    this.sterilizer = ""; //初期値

    // 確認日補完用 
    this.dateSub = ""; //初期値

    // URLから対象のJSON情報を取得
    this.bodyData = "";
    this.mode = "";
    this.id = "";
    if ((this.$route.params.bodyData) && (this.$route.params.id) && (this.$route.params.mode)) {
      this.bodyData = JSON.parse(decodeURIComponent(this.$route.params.bodyData));

      // 編集時のみ確認日を補完 
      this.mode = JSON.parse(decodeURIComponent(this.$route.params.mode));
      if(this.mode == "EDIT") {
        this.dateSub = this.bodyData.date;
        this.date_api = this.bodyData.date.replace(/-/g, "/");
      }

      this.id = JSON.parse(decodeURIComponent(this.$route.params.id));
    }

    // 新規登録時
    if(this.mode == "") {
      // 最新生産情報補完モードに設定
      this.mode = "LATEST"
      // 最新生産情報取得
      this.bodyData = this.latestSearch();
      // 水揚げ日を補完
      if (this.bodyData) {
        this.dateSub = this.bodyData.date;
        this.date_api = this.bodyData.date.replace(/-/g, "/");
      }
    }

    this.$nextTick(() => {
      this.loadData();
    });

    return {
      events: {},
      menu: "",
      view_status: {
        editable: false,
      },
      errors: [],
      formData: {
        chlorineConcentration: "",
        seawaterTemperature: "",
        salinity: "",
      },
      filterBackwash: "",
      filterSupply: "",
      filterExchange: "",
      chlorine: "",
      uv: "",
      uvStatus: "",
    };
  },
  methods: {
    /**
     * ろ過器の管理関連
     */
    buildFiltermaintenanceData() {
      var workFilterMaintenance = {
        backwash: "",
        supply: "",
        exchange: "",
      };
      // ろ過器の管理(逆洗)未選択時の処理
      if (this.filterBackwash == "") {
        this.filterBackwash = false;
      }
      // ろ過器の管理(ろ材補充)未選択時の処理
      if (this.filterSupply == "") {
        this.filterSupply = false;
      }
      // ろ過器の管理(ろ材交換)未選択時の処理
      if (this.filterExchange == "") {
        this.filterExchange = false;
      }
      workFilterMaintenance.backwash = this.filterBackwash;
      workFilterMaintenance.supply = this.filterSupply;
      workFilterMaintenance.exchange = this.filterExchange;
      this.filterMaintenance = workFilterMaintenance;
    },
    /**
     * 殺菌装置関連
     */
    buildSterilizerData() {
      var workSterilizer = {
        chlorine: "",
        chlorine_concentration: "",
        uv: "",
        uv_status: "",
      };
      // 殺菌装置(塩素)未選択時の処理
      if (this.chlorine == "") {
        this.chlorine = false;
      }
      // 殺菌装置(紫外線)未選択時の処理
      if (this.uv == "") {
        this.uv = false;
      }
      // 塩素
      workSterilizer.chlorine = this.chlorine;
      // 残留塩素濃度
      if (this.formData.chlorineConcentration === "") {
        workSterilizer.chlorine_concentration = -1;
      } else {
        workSterilizer.chlorine_concentration =
          this.formData.chlorineConcentration;
      }
      // 紫外線
      workSterilizer.uv = this.uv;
      // 紫外線稼働状況
      switch (this.uvStatus) {
        case 1:
          workSterilizer.uv_status = 1;
          break;
        case 2:
          workSterilizer.uv_status = 0;
          break;
        default:
          workSterilizer.uv_status = -1;
          break;
      }
      this.sterilizer = workSterilizer;
    },
    /**
     * 使用海水画面にデータを設定する
     */
    setData(data) {
      this.filterBackwash = data.filter_maintenance.backwash;
      this.filterSupply = data.filter_maintenance.supply;
      this.filterExchange = data.filter_maintenance.exchange;
      this.chlorine = data.sterilizer.chlorine;
      this.uv = data.sterilizer.uv;

      if (this.mode == "EDIT") {
        this.formData.chlorineConcentration =
          data.sterilizer.chlorine_concentration;
        if (this.formData.chlorineConcentration == -1) {
          this.formData.chlorineConcentration = "";
        }
        // 紫外線稼働状況
        switch (data.sterilizer.uv_status) {
          case 1:
            this.uvStatus = 1;
            break;
          case 0:
            this.uvStatus = 2;
            break;
          default:
            this.uvStatus = -1;
            break;
        }
        this.formData.seawaterTemperature = data.water_temperature;
        if (this.formData.seawaterTemperature == 9999) {
          this.formData.seawaterTemperature = "";
        }
        this.formData.salinity = data.salinity;
      }
    },
    /**
     * 使用海水画面関連
     */
    loadData() {
      // APIの実行中は画面を編集不可にする
      this.view_status.editable = false;

      if (this.bodyData) {
        // 画面にデータを設定する
        this.setData(this.bodyData);
      }

      // 画面を編集可能にする
      this.view_status.editable = true;
    },

    /**
     * 登録日を更新する
     */
    updateRegistrationDate(registrationDate) {
      // API指定用登録日
      this.date_api = registrationDate.replace(/-/g, "/");
    },
    /**
     * カレンダーの月間イベント更新
     */
    updateCalendarEvent(registrationDate) {
      this.applyDataToMonthlyArea(registrationDate);
    },
    /**
     * カレンダー表示用月間イベント取得処理
     */
    applyDataToMonthlyArea(date) {
      const { apiList, mapping } = this.haccpInfoRequest({
        date: new DateWrapper(date),
        daily: false,
        requireUserInfo: false,
      });

      this.$nextTick(() => {
        // APIのリクエスト
        this.$store.commit("setWaiting", true);
        Promise.all(apiList)
          .then((result) => {
            this.$store.commit("setWaiting", false);
            this.events = {
              unloading: result[mapping.unloading].record_list.map(
                (item) => new DateWrapper(item.record_date).format.systemDate
              ),
              shipping: result[mapping.shipping].record_list.map(
                (item) => new DateWrapper(item.record_date).format.systemDate
              ),
              seawater: result[mapping.seawater].record_list.map(
                (item) => new DateWrapper(item.record_date).format.systemDate
              ),
              worklog: result[mapping.worklog].record_list.map(
                (item) => new DateWrapper(item.record_date).format.systemDate
              ),
            };
          })
          .catch((error) => {
            this.$store.commit("setWaiting", false);
            if (error.status == 403) {
              this.errors.push(AlertBuilder.error("権限がありません"));
            } else {
              Api.resolve(error);
            }
          });
      });
    },
    haccpInfoRequest(parameter) {
      const date = parameter["date"] || new DateWrapper(Date.now());
      const daily = parameter["daily"] || false;
      const requireUserInfo = parameter["requireUserInfo"] || false;

      let requestDate = {
        year: date.format.build((d) => new String(d.date.y)),
        month: date.format.build((d) => new String(d.date.m02)),
      };
      if (daily) {
        requestDate["day"] = date.format.build((d) => new String(d.date.d02));
      }
      var apiList = [];
      var keys = [];
      if (requireUserInfo) {
        keys.push("user");
        apiList.push(
          Api.call("/admin/user", {
            purpose: "VIEW_HACCP",
          })
        );
      }

      keys.push(...["worklog", "shipping", "unloading", "seawater"]);
      apiList.push(
        ...[
          Api.call("/work/record", {
            uid: this.$store.getters.userId,
            record_type: "WORKLOG",
            record_date: requestDate,
          }),
          Api.call("/haccp/record", {
            uid: this.$store.getters.userId,
            record_type: "SHIPPING",
            record_date: requestDate,
          }),
          Api.call("/haccp/record", {
            uid: this.$store.getters.userId,
            record_type: "UNLOADING",
            record_date: requestDate,
          }),
          Api.call("/haccp/record", {
            uid: this.$store.getters.userId,
            record_type: "SEAWATER",
            record_date: requestDate,
          }),
        ]
      );
      return {
        apiList: apiList,
        mapping: keys.reduce((map, key, index) => {
          map[key] = index;
          return map;
        }, {}),
      };
    },

    /**
     * エラーメッセージをクリアする
     */
    clearMessage() {
      this.errors = [];
    },
    /**
     * エラーメッセージを表示する
     */
    showMessage(error) {
      this.errors.push(error);
      window.scrollTo(0, 0);
    },

    /**
     * 冷却海水温度 入力チェック
     * エラーがあればtrueを返す
     */
    hasErrorSeawaterTemperature() {
      if (this.formData.seawaterTemperature === "") {
        return true;
      } else {
        if (Validate.hasError([this.$v.formData.seawaterTemperature])) {
          return true;
        }
        return false;
      }
    },
    /**
     * 塩分濃度 入力チェック
     * エラーがあればtrueを返す
     */
    hasErrorSalinity() {
      if (this.formData.salinity === "") {
        return true;
      } else {
        if (Validate.hasError([this.$v.formData.salinity])) {
          return true;
        }
        return false;
      }
    },
    /**
     * 格納データを作成する
     */
    buildbodyBodyData() {
      var workSeawaterTemperature = "";
      if (this.formData.seawaterTemperature === "") {
        workSeawaterTemperature = "9999";
      } else {
        workSeawaterTemperature = this.formData.seawaterTemperature;
      }
      return {
        type: "SEAWATER",
        date: this.date_api,
        filter_maintenance: this.filterMaintenance,
        sterilizer: this.sterilizer,
        water_temperature: Number(workSeawaterTemperature),
        salinity: this.formData.salinity,
      };
    },
    /**
     * 登録用送信データを画面から取得する
     */
    buildRegisterData() {
      switch (this.mode) {
        case "EDIT": // 編集
          return {
            record_type: "SEAWATER",
            record_date: this.date_api,
            body: this.buildbodyBodyData(),
            record_id: this.workId,
          };
        case "COPY": // コピー
          return {
            record_type: "SEAWATER",
            record_date: this.date_api,
            body: this.buildbodyBodyData(),
          };
        default: // 新規
          return {
            record_type: "SEAWATER",
            record_date: this.date_api,
            body: this.buildbodyBodyData(),
          };
      }
    },
    /**
     * 更新用登録データを画面から取得する
     */
    buildUpdateData() {},
    /**
     * 保存ボタン押下時に入力内容をチェックする
     */
    inputCheck() {
      this.clearMessage();

      // 入力チェック
      if (this.hasErrorFormData) {
        this.showMessage(AlertBuilder.error("入力した項目が不正です"));
        return;
      }
      if (
        this.cardColor1 === CARD_COLOR_ERROR ||
        this.cardColor2 === CARD_COLOR_ERROR ||
        this.cardColor3 === CARD_COLOR_ERROR ||
        this.cardColor4 === CARD_COLOR_ERROR ||
        this.cardColor5 === CARD_COLOR_ERROR
      ) {
        this.showMessage(AlertBuilder.error("必須項目が入力されていません"));
        return;
      }

      if (
        this.chlorineConcentrationMsg != "" ||
        this.seawaterTemperatureMsg != "" ||
        this.uvMsg != "" ||
        this.salinityMsg != ""
      ) {
        // 入力チェックダイアログを表示する
        this.$refs.confirm_input_check.showDialog();
        return;
      }

      this.register();
    },
    /**
     * 最新生産情報取得用送信データを設定する
     */
    buildLatestSearchData() {
      return {
        uid: this.$store.getters.userId,
        record_type: "SEAWATER",
      };
    },
    /**
     * 取得情報を設定して画面にデータを設定する
     */
    setlatestData(data) {
      this.bodyData = data;
      this.loadData();
    },
    /**
     * 最新生産情報を取得する
     */
    latestSearch() {
      let selectUrl = "";
      let postData = null;

      selectUrl = "/haccp/record/latest";

      postData = this.buildLatestSearchData();

      this.$store.commit("setWaiting", true);

      // APIを実行する
      Api.call(selectUrl, postData)
        .then((result) => {
          this.$store.commit("setWaiting", false);
          this.setlatestData(result.body);
        })
        .catch((error) => {
          this.$store.commit("setWaiting", false);
          const message = valueMapper
            .map({
              401: AlertBuilder.invalid(),
            })
            .getOrElse(error.status, AlertBuilder.invalid());
          // 初回の新規登録時は対象レコードが存在しない為、400が返却されるがエラー扱いとしない
          if ((message.isInvalid) && (error.status != 400)) {
            Api.resolve(error);
          } else {
            this.showMessage(message);
          }
        });
    },
    register() {
      // ろ過器の管理関連
      this.buildFiltermaintenanceData();
      // 殺菌装置関連
      this.buildSterilizerData();

      // 生産情報登録
      let updateUrl = "";
      let postData = null;

      updateUrl = "/haccp/record/update";
      // 編集時のみid指定
      this.workId = "";
      if (this.mode == "EDIT") {
        this.workId = this.id;
      }
      postData = this.buildRegisterData();

      this.$store.commit("setWaiting", true);

      Api.call(updateUrl, postData)
        .then(() => {
          this.$store.commit("setWaiting", false);
          this.$router.push("/product");
        })
        .catch((error) => {
          this.$store.commit("setWaiting", false);
          const message = valueMapper
            .map({
              400: AlertBuilder.error("更新に失敗しました"),
              401: AlertBuilder.invalid(),
              403: AlertBuilder.error("権限がありません"),
            })
            .getOrElse(error.status, AlertBuilder.invalid());
          if (message.isInvalid) {
            Api.resolve(error);
          } else {
            this.showMessage(message);
          }
        });
    },
    cancel() {
      this.$router.push("/product");
    },
  },
};
</script>

<style scoped>
.card-warning {
  background-color: #fff8dc;
}
.card-error {
  background-color: #ffdbe2;
}
.custom-card-title {
  font-size: 32px;
  color: #333;
  line-height: 1.5;
}
.custom-card-subtitle {
  font-size: 24px;
  line-height: 1.5;
}
.custom-card-text {
  font-size: 24px;
  line-height: 1.3;
}
.big-checkbox {
  transform: scale(1.4);
  font-size: 24px;
  margin-left: 24px;
  margin-right: 24px;
}
.big-radio-group {
  transform: scale(1.4);
  font-size: 24px;
  margin-left: 32px;
  margin-right: 32px;
}
</style>
